/*
 * Export API — dispatches to the localStorage mock (client-side PDF) or the
 * real HTTP backend (QuestPDF) based on USE_MOCK_API.
 */
import { USE_MOCK_API } from './httpClient'
import * as mock from './export.mock'
import * as http from './export.http'

const impl = USE_MOCK_API ? mock : http

export const exportTripPdf: (tripId: string, template?: string) => Promise<Blob> = impl.exportTripPdf
export const exportTripFilm: (tripId: string, style?: string) => Promise<Blob> = impl.exportTripFilm
